import React from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import Checkbox from "../../../../components/Checkbox";
import Loader from "../../../../components/Loader";
import Row from "./Row";

const Table = ({ items, title, selectedContracts = [], onSelectContract, onSelectAll }) => {
  // Calculer si tous les éléments sont sélectionnés
  const allSelected = items.length > 0 && items.every(item => selectedContracts.includes(item.id));

  // Gérer la sélection/désélection de tous les contrats
  const handleSelectAll = () => {
    if (onSelectAll) {
      onSelectAll(!allSelected);
    }
  };

  // Gérer la sélection/désélection d'un contrat
  const handleSelectContract = (id, isSelected) => {
    if (onSelectContract) {
      onSelectContract(id, isSelected);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.table}>
        <div className={styles.row}>
          <div className={styles.col}>
            <Checkbox
              className={styles.checkbox}
              value={allSelected}
              onChange={handleSelectAll}
            />
          </div>
          <div className={styles.col}>Contrat / Convention</div>
          <div className={styles.col}>Statut validation</div>
          <div className={styles.col}>Statut signature</div>
          <div className={styles.col}>Date</div>
        </div>
        {items.map((x, index) => (
          <Row
            item={x}
            key={index}
            index={index}
            value={selectedContracts.includes(x.id)}
            onChange={(isChecked) => handleSelectContract(x.id, isChecked)}
          />
        ))}
      </div>
    </div>
  );
};

export default Table;
